





















































































































































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import hexabaseState from '@/store/hexabase';

import Input from '@/components/common/elements/Input.vue';
import InputNoVModel from '@/components/common/elements/InputNoVModel.vue';
import SelectNoVModel from '@/components/common/elements/SelectNoVModel.vue'
import MasterSelectMultiSetControl from '@/components/common/modules/MasterSelectMultiSetControl.vue';
import Button from '@/components/common/elements/Button.vue';

import { HexaFileFieldResponse } from '@/services/hexabase/types';
import FileManagerForm from '@/components/form/FileManagerForm.vue';
import FileManager from '@/components/common/modules/FileManager.vue';
import FileClass from '@/models/lib/file';

@Component({
  components: {
    Input,
    InputNoVModel,
    SelectNoVModel,
    MasterSelectMultiSetControl,
    Button,
    FileManagerForm,
    FileManager,
  },
})
export default class FixedMatterInformationTab extends Vue {
  inheritAttrs = false;

  @Prop({ default: () => ({}) })
  private item: any;

  private projectId = hexabaseState.applicationId;
  private mainDsId = '';

  // プログレス関連
  private isCancelDisable = false;
  private isSubmitDisable = false;
  // ファイル情報周り
  // private inputFiles: File[] = [];
  private localModifyRules = '';
  private uploadTargetItem = '';

  private dialogQuotationRegistrationStatus = false;

  /**
   * 親コンポーネントに入力値を通知する
   * @param data - 入力値
   * @param index - 入力行番号
   */
  @Emit('inputOperation')
  public inputOperation(data: any, index: number) {
    this.emit({ action: 'inputOperation', data: data, index: index });
  }

  private fileUpload() {
    // ファイルコンポ―ネントへアップロード通知
    this.emit({ action: 'fileUpload' });
  }

  private listAction(response: any) {
    this.emit({ action: 'listAction', input: response });
  }

  private setInputFiles(files: File[]) {
    this.emit({ action: 'inputFiles', files });
  }

  private detailButtonClick(value: any) {
    if (value !== undefined) {
      this.emit({ action: 'clickRowOpratipon', data: value });
    }
  }

  @Emit('tabChildrenEventRelay')
  private emit(response: any) {
    return response;
  }

  // 実行ボタン制御
  private setSubmitDisable(invalid: boolean, errors: { [x: string]: string[] }): boolean {
    let obj: string[] = [];
    for (const [key, value] of Object.entries(errors)) {
      if (value.length > 0) {
        obj = [...obj, key];
      }
    }
    let passFlg = false;
    if (obj.length === 1 && obj[0] === 'count') {
      passFlg = true;
    }

    if (this.item.inputFiles && this.item.inputFiles.length === 0) return true;
    if (passFlg) return false;
    return invalid;
  }
}
